$(window).on('load', function(){

    // Initial DOM References
    var $shape          = $('.follow-graphic');
    var $startObject    = $('.perspective .image img');
    var $endObject      = $('.map');
    var $window         = $(window);
    var $container      = $('.container');
    var $shapePortions  = $('.cls-1');
    var $imageContainer = $('.perspective .image')

    // No avoiding it - Manual Offset Adjusts
    // This code will out-of-the box get you 90% the way there, 
    // Use these values to nudge it the rest of the way.
    var startOffsetTop  = 30;
    var endOffsetTop  = 240;
    var endOffsetRight  = 30;

    // Important Values
    var startPoint;     
    var endPoint;        
    var viewportHeight; 
    var offsetStartRight;
    var shapeHeight     = $shape.outerHeight();
    var shapeWidth     = $shape.outerWidth();


    // Function to set Values Dynamically
    var setValues           = function() {
        viewportHeight      = $window.height();
        viewportWidth       = $window.width();
        containerWidth      = $container.width();
        startPoint          = ($startObject.offset().top + $startObject.outerHeight()) - 
                              ($startObject.outerHeight() - ($startObject.outerHeight() / 2)) - (shapeHeight / 2);
        endPoint            = 870;
        offsetStartRight    = ((viewportWidth - containerWidth) / 2) + ((($startObject.width() / 2) - 60) - ($shape.width() / 2));
        offsetEndRight      = 970;
    }

    setValues();
    $window.resize(setValues);

    $window.scroll(function(){

        let scrollTop = $window.scrollTop();
        setValues();

        if ((scrollTop + ($endObject.outerHeight() / 2)) > $endObject.offset().top ) {
            if (viewportWidth > 992) {
                $shape.css('top', endPoint);
                $shape.css('right', offsetEndRight);
                $shape.css('width', '295px');
                $shapePortions.css('fill', '#2DB9E1');
                $shape.addClass('second-state');
            }
        } else {
            $shape.css('top', startPoint + startOffsetTop);
            $shape.css('right', offsetStartRight);
            $shape.css('width', shapeWidth + 'px');
            $shapePortions.css('fill', '#266092');
            $shape.removeClass('second-state');
            $shape.removeAttr('style');
        }
    });

}); 